function r(e,n){return e=e||"",new RegExp("^(?:"+n+")$").test(e)}export{r as default};
